<template>
  <div class="local-storage">
    <dt class="title">LocalStorage: {{ items.length }} items</dt>
    <dl v-for="(item, index) in items" :key="index" class="key">
      <form-entity :model="item" :rules="rules" class="form-edit"
        v-if="isEdit"
      >
        <div class="item-btns">
          <span>{{index + 1}}</span>
          <mt-button @click="copyItem({ index, item }, $event)">复制</mt-button>
        </div>
        <form-field
          prop="key"
          :default-focus="false"
          :options="{ label: 'key', readonly: true, placeholder: '', type: 'text', required: true }"
        />
        <form-field
          prop="value"
          :default-focus="false"
          :options="{ label: 'value', readonly: true, placeholder: '', type: 'text', required: true }"
        />
       
      </form-entity>
      
      <div v-else>
        <span>{{index + 1}}:</span>
        <span>{{ item.key }}</span>
        <div class="value" v-if="item.value.indexOf('{') === 0">
          <span>{{ JSON.parse(item.value) }}</span>
        </div>
        <span class="value" v-else>{{ item.value }}</span>
      </div>
    </dl>
    <input v-if="isSuper" type="number" v-model="userID" placeholder="输入用户ID">
    <div class="action-btns">
      <mt-button @click="clear">清除全部</mt-button>
      <!-- <mt-button @click="clearPhone">清除手机</mt-button>-->
      <mt-button v-if="isSuper" @click="testPhone">登录</mt-button> 
    </div>
  </div>
</template>

<script>
import { storage } from '@/utils'
import copyText from '@/utils/clipboard'
export default {
  name: 'LocalClear',
  data() {
    return {
      items: this.getItems(),
      userID: ''
    }
  },
  computed: {
    isEdit() {
      return this.$route.query.isEdit !== undefined
    },
    isSuper() {
      return this.$route.query.isSuper !== undefined
    }
  },
  methods: {
    clear() {
      localStorage.clear()
      this.items = this.getItems()
    },
    clearPhone() {
      storage.AppUserKey().remove()
      storage.AppUserKeySwitch().setItem({ switchPhone: true })
      this.items = this.getItems()
    },
    testPhone() {
      const token = 'ojzmNwCW67xlJN3J1RXU2KgJ6xR;_4oamELwXldpOrteNqovFB4egh4Imk$'
      storage.AppUserKey().setItem({ 'userModel': { 'accountStatus': 0, 'avtarUrl': 'https://img-cdn1.ylyk.com/avatar/avatar-5407446.jpg', 'mobileNumber': 'test', 'nickname': '宁', 'userID': this.userID, 'questionStatus': 1 }, 'token': token.replace('_', '') })
      storage.AppUserKeySwitch().remove()
      this.items = this.getItems()
    },
    copyItem({ index, item }, $event) {
      const text = `${index}: ${item.key}\n${item.value}`
      copyText(text, $event)
    },
    getItems() {
      const items = []
      Object.keys(localStorage)
        .filter(key => key.indexOf('USER') >= 0)
        .forEach(key => {
          let value = localStorage.getItem(key)
          value = typeof (value) === 'object' ? JSON.parse(value) : value
          items.push({ key, value })
        })
      return items
    }
  }
}
</script>

<style lang="scss" scoped>
.local-storage {
  margin: 20px;
  background-color: white;
  .title {
    font-size: 16px;
  }
  .key {
    font-size: 14px;
    margin: 10px;
    border-bottom: 1px solid #d9d9d9;
    padding: 10px;
    .value {
      color: #c8c8c8;
      word-break: break-all;
    }
  }
  .item-btns {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .action-btns {
    .mint-button {
      margin: 0 10px;
    }
  }
}
</style>